import uuid from 'node-uuid'
import FileSaver from 'file-saver'
import moment from 'moment'
import {apiUrl, apiOption, apiResponse, errorResponse} from '../core/fetchz'
import loading from '../core/redux/loading'
import progress from '../core/redux/progress'
import config from '../config'
import i18n from '../i18n'
import {Criteria} from './models'
import {START_XLSX_EXPORT, XLSX_EXPORT_COMPLETED, START_PDF_EXPORT, PDF_EXPORT_COMPLETED, START_PDF_REPORT, PDF_REPORT_COMPLETED} from './protocol'
import {loadPatrimony} from '../patrimony/actions'

const NAMESPACE = 'Ticket'
export const LINKS_LOADED = NAMESPACE + '/LinksLoaded'
export const TICKET_STREAM_LOADED = NAMESPACE + '/TicketStreamLoaded'
export const TICKET_STREAM_QUERIED = NAMESPACE + '/TicketStreamQueried'
export const MINOR_TICKET_STREAM_QUERIED = NAMESPACE + '/MinorTicketStreamQueried'
export const TICKET_LOADED = NAMESPACE + '/TicketLoaded'
export const TICKET_CREATED = NAMESPACE + '/TicketCreated'
export const CRITERIA_UPDATED = NAMESPACE + '/CriteriaUpdated'
export const OPEN_TICKET_CMD_SENT = NAMESPACE + '/OpenTicketCmdSent'
export const OPEN_TICKET_CMD_RESET = NAMESPACE + '/OpenTicketCmdReset'
export const IDENTIFY_ASSIGNEE_CMD_SENT = NAMESPACE + '/IdentifyAssigneeCmdSent'
export const REPORT_SENDING_SERVICE_ORDER_CMD_SENT = NAMESPACE + '/ReportSendingServiceOrderCmdSent'
export const DEFINE_INTERVENTION_DEADLINE_CMD_SENT = NAMESPACE + '/DefineInterventionDeadlineCmdSent'
export const REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT = NAMESPACE + '/ReportFormalNoticeForProviderCmdSent'
export const REQUEST_INTERVENTION_CMD_SENT = NAMESPACE + '/RequestInterventionCmdSent'
export const ACCEPT_INTERVENTION_CMD_SENT = NAMESPACE + '/AcceptInterventionCmdSent'
export const REFUSE_INTERVENTION_CMD_SENT = NAMESPACE + '/RefuseInterventionCmdSent'
export const SCHEDULE_INTERVENTION_CMD_SENT = NAMESPACE + '/ScheduleInterventionCmdSent'
export const START_INTERVENTION_CMD_SENT = NAMESPACE + '/StartInterventionCmdSent'
export const FINISH_INTERVENTION_CMD_SENT = NAMESPACE + '/FinishInterventionCmdSent'
export const ADD_MESSAGE_CMD_SENT = NAMESPACE + '/AddMessageCmdSent'
export const CLOSE_TICKET_CMD_SENT = NAMESPACE + '/CloseTicketCmdSent'
export const CORRECT_TICKET_INFORMATIONS_CMD_SENT = NAMESPACE + '/CorrectTicketInformationsCmdSent'
export const CORRECT_TICKET_INFORMATIONS_CMD_RESET = NAMESPACE + '/CorrectTicketInformationsCmdReset'
export const CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT = NAMESPACE + '/CorrectTicketEventInformationsCmdSent'
export const RECEIVE_CALL_CMD_SENT = NAMESPACE + '/ReceiveCallCmdSent'
export const EMIT_CALL_TO_CMD_SENT = NAMESPACE + '/EmitCallToCmdSent'
export const FINISH_MISSION_CMD_SENT = NAMESPACE + '/FinishMissionCmdSent'
export const XLSX_TICKETS_EXPORTED = NAMESPACE + '/XlsxTicketsExported'
export const PDF_TICKETS_EXPORTED = NAMESPACE + '/PdfTicketsExported'
export const PDF_TICKETS_REPORTED = NAMESPACE + '/PdfTicketsReported'
// form actions
export const EXPORT_XLSX_TICKETS_OPTION_UPDATED = NAMESPACE + '/ExportXlsxTicketsOptionUpdated'
export const EXPORT_PDF_TICKETS_OPTION_UPDATED = NAMESPACE + '/ExportPdfTicketsOptionUpdated'
export const REPORT_PDF_TICKETS_OPTION_UPDATED = NAMESPACE + '/ReportPdfTicketsOptionUpdated'
export const OPEN_TICKET_CMD_UPDATED = NAMESPACE + '/OpenTicketCmdUpdated'
export const CORRECT_LOCATION_REFERENCE_CMD_UPDATED = NAMESPACE + '/CorrectLocationReferenceCmdUpdated'
export const CORRECT_LOCATION_REFERENCE_CMD_SENT = NAMESPACE + '/CorrectLocationReferenceCmdSent'
export const CORRECT_LOCATION_REFERENCE_CMD_RESET = NAMESPACE + '/CorrectLocationReferenceCmdReset'
export const CORRECT_CALLER_CMD_UPDATED = NAMESPACE + '/CorrectCallerCmdUpdated'
export const IDENTIFY_ASSIGNEE_CMD_UPDATED = NAMESPACE + '/IdentifyAssigneeCmdUpdated'
export const REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED = NAMESPACE + '/ReportSendingServiceOrderCmdUpdated'
export const DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED = NAMESPACE + '/DefineInterventionDeadlineCmdUpdated'
export const REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED = NAMESPACE + '/ReportFormalNoticeForProviderCmdUpdated'
export const SCHEDULE_INTERVENTION_CMD_UPDATED = NAMESPACE + '/ScheduleInterventionCmdUpdated'
export const START_INTERVENTION_CMD_UPDATED = NAMESPACE + '/StartInterventionCmdUpdated'
export const FINISH_INTERVENTION_CMD_UPDATED = NAMESPACE + '/FinishInterventionCmdUpdated'
export const ADD_MESSAGE_CMD_UPDATED = NAMESPACE + '/AddMessageCmdUpdated'
export const CLOSE_TICKET_CMD_UPDATED = NAMESPACE + '/CloseTicketCmdUpdated'
export const CORRECT_TICKET_INFORMATIONS_CMD_UPDATED = NAMESPACE + '/CorrectTicketInformationsCmdUpdated'
export const CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED = NAMESPACE + '/CorrectTicketEventInformationsCmdUpdated'
export const RECEIVE_CALL_CMD_UPDATED = NAMESPACE + '/ReceiveCallCmdUpdated'
export const EMIT_CALL_TO_CMD_UPDATED = NAMESPACE + '/EmitCallToCmdUpdated'
export const FINISH_MISSION_CMD_UPDATED = NAMESPACE + '/FinishMissionCmdUpdated'
export const ACCEPT_INTERVENTION_CMD_UPDATED = NAMESPACE + '/AcceptInterventionCmdUpdated'
export const ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL = NAMESPACE + '/AcceptInterventionCmdUpdatedEmail'
export const RESTRICT_ACCESS_CMD_SENT = NAMESPACE + '/RestrictAccessCmdSent'
export const CORRECT_OTP = NAMESPACE + '/CorrectOTP'

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_TICKET_QUERY = {
    ...DEFAULT_QUERY,
    fullText: null,
    status: null,
    location: null,
    clientCompany: null,
    agency: null,
    callPurpose: null,
    from: null,
    to: null,
    activeProviders: null,
    patrimony: null
}

export function loadLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/tickets', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: LINKS_LOADED,
            _links: json._links
        }
    }), LINKS_LOADED)
}

export function queryTicketStream(ticketQuery) {
    return loadTicketStream(ticketQuery, TICKET_STREAM_QUERIED)
}

export function queryMinorTicketStream(ticketQuery) {
    return loadTicketStream(ticketQuery, MINOR_TICKET_STREAM_QUERIED)
}

export function loadTicketStream(ticketQuery, action) {
    return loading((state) => {
        const {query} = state.ticket

        ticketQuery = {
            ...DEFAULT_TICKET_QUERY,
            ...query,
            ...ticketQuery
        }

        const ticketsPromise = fetch(apiUrl(config.api.url + '/tickets', ticketQuery), apiOption()).then(apiResponse)
        const statsPromise = fetch(apiUrl(config.api.url + '/tickets/stats', ticketQuery), apiOption()).then(apiResponse)

        return Promise.all([ticketsPromise, statsPromise]).then(([ticketsResponse, statsResponse]) => {
            return {
                type: action || TICKET_STREAM_LOADED,
                range: ticketsResponse.headers.contentRange,
                stream: ticketsResponse.json.result,
                aggregations: ticketsResponse.json.aggregations,
                _links: ticketsResponse.json._links,
                stats: statsResponse.json,
                query: ticketQuery,
            }
        })
    }, action || TICKET_STREAM_LOADED)
}

export function enterTicket(dispatch, params) {
    return dispatch(loadTicket(params.id))
        .then((loadTicketAction) => {
            const patrimony = loadTicketAction.ticket.linkedEntities.patrimony
            return Promise.all([
                patrimony && dispatch(loadPatrimony(patrimony.uid)),
            ])
        })
}

export function loadTicket(id) {
    return loading((state) => {
        const {ticket} = state.ticket
        id = id || ticket.uid

        return fetch(apiUrl(config.api.url + '/tickets/' + id), apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: TICKET_LOADED,
                ticket: json
            }
        })
    }, TICKET_LOADED)
}

export function restrictAccessToCall(dispatch) {
    return _ => {
        return dispatch(loading((state) => {
            const option = {
                body: {
                    processUid: uuid.v4(),
                    'commandType': 'RestrictAccessToTicket',
                    accessControlList: [{
                        'accessControlType': 'PatrimonyUser',
                        'accessGrantTo': 'TicketCaller'
                    }]
                },
                method: 'PATCH'

            }

            return fetch(config.api.event.url + '/tickets/' + state.ticket.ticket.uid, apiOption(option))
                .then(apiResponse)
                .then(json => ({
                        type: RESTRICT_ACCESS_CMD_SENT,
                        events: json.events
                }))
        }, RESTRICT_ACCESS_CMD_SENT))
    }
}

export function sendOpenTicketCmd() {
    return loading((state) => {
        const {openTicketCmd} = state.ticket
        const {
                ticket: {
                    callerz: {namez, uid, ...callerz},
                    contactToCallback,
                    address: {number, street, digicode, staircase, floor, ...address},
                    openingTicketPurpose, request, ...ticket
                }, locationRef, restrictedAccess, requestUid, qualification
            } = openTicketCmd
        const recipientSupplement = floor || staircase ? {recipientSupplement: {floor, staircase}} : undefined

        const option = {
            body: {
                processUid: uuid.v4(),
                openedDate: new Date(),
                locationRef: {
                    ...locationRef,
                    agencyUid: locationRef.agencyUid && locationRef.agencyUid.uid,
                    patrimonyUid: locationRef.patrimonyUid && locationRef.patrimonyUid.uid
                },
                ticket: {
                    address: {
                        street: [number, street].filter((v) => v).join(', '),
                        complement: [digicode && ('digicode: ' + digicode)].filter((v) => v).join(', '),
                        ...recipientSupplement,
                        ...address
                    },
                    caller: {
                        uid: uid && uid.uid,
                        name: namez && {nameType: 'CivilName', ...namez},
                        ...callerz
                    },
                    contactToCallback: contactToCallback && {
                        name: contactToCallback.namez,
                        ...contactToCallback
                    },
                    callPurposeLabel: openingTicketPurpose.label,
                    callPurposeUid: openingTicketPurpose.uid,
                    altCallPurpose: {},
                    additionalData: {},
                    claimNumber: {},
                    request: request,
                    ...ticket
                },
                ...((Boolean(restrictedAccess)) ? {
                    accessControlList: [{
                        'accessControlType': 'PatrimonyUser',
                        'accessGrantTo': 'TicketCaller'
                    }]
                } : {}),
                ...(Boolean(requestUid) ? {fromSimplifiedRequest: requestUid} : {}),
                ...(qualification ? {qualification} : {}),
                commandType: 'OpenTicket'
            }
        }

        return fetch(config.api.event.url + '/tickets', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: OPEN_TICKET_CMD_SENT,
                events: json.events
            }
        })
    }, OPEN_TICKET_CMD_SENT)
}

export function sendSimplifiedRequestQualified(requestUid, ticketUid) {
    if (!requestUid) {
        return Promise.resolve()
    }
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            ticketUid: ticketUid,
            commandType: 'QualifySimplifiedRequest',
        }
    }
    return fetch(config.api.event.url + '/simplifiedrequests/' + requestUid, apiOption(option))
        .then(apiResponse)
}

export function sendIdentifyAssigneeCmd(ticketId) {
    return loading((state) => {
        const {ticket, identifyAssigneeCmd} = state.ticket
        const {assignee, ...cmd} = identifyAssigneeCmd
        ticketId = ticketId || ticket.uid

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                assignee: {
                    ...assignee,
                    providerUid: assignee.providerUid.uid
                },
                commandType: 'IdentifyAssignee',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticketId, apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: IDENTIFY_ASSIGNEE_CMD_SENT,
                events: json.events
            }
        })
    }, IDENTIFY_ASSIGNEE_CMD_SENT)
}

export function sendReportSendingServiceOrderCmd() {
    return loading((state) => {
        const {ticket, reportSendingServiceOrderCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                reportDate: new Date(),
                assignee: cmdAssignee(assignee),
                commandType: 'ReportSendingServiceOrder',
                ...reportSendingServiceOrderCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REPORT_SENDING_SERVICE_ORDER_CMD_SENT
            }
        })
    }, REPORT_SENDING_SERVICE_ORDER_CMD_SENT)
}

export function sendDefineInterventionDeadlineCmd() {
    return loading((state) => {
        const {ticket, defineInterventionDeadlineCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                assignee: cmdAssignee(assignee),
                commandType: 'DefineInterventionDeadline',
                ...defineInterventionDeadlineCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_INTERVENTION_DEADLINE_CMD_SENT
            }
        })
    }, DEFINE_INTERVENTION_DEADLINE_CMD_SENT)
}

export function sendReportFormalNoticeForProviderCmd() {
    return loading((state) => {
        const {ticket, reportFormalNoticeForProviderCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                reportDate: new Date(),
                assignee: cmdAssignee(assignee),
                commandType: 'ReportFormalNoticeForProvider',
                ...reportFormalNoticeForProviderCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT
            }
        })
    }, REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT)
}

export function sendRequestInterventionCmd() {
    // this cmd is considered a specialised version of EmitCallToCmd

    return loading((state) => {
        const {ticket, emitCallToCmd} = state.ticket
        const {assignee} = ticket
        const {recipient, ...cmd} = emitCallToCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                assignee: cmdAssignee(assignee),
                commandType: 'RequestIntervention',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REQUEST_INTERVENTION_CMD_SENT
            }
        })
    }, REQUEST_INTERVENTION_CMD_SENT)
}

export function sendAcceptInterventionCmd(ticketId) {
    return loading((store) => {
        const {ticket, acceptInterventionCmd} = store.ticket
        const {assignee} = ticket
        const {sendItOrNot, otherEmails} = acceptInterventionCmd
        const ticketId = ticketId || ticket.uid

        const otherRecipients = otherEmails.filter(Boolean)
        const assigneeEmail = ((assignee && sendItOrNot === 'doNotSendNotif') ? null : sendItOrNot)
        const requestNotificationTo = assigneeEmail ?  {requestNotificationTo: {assigneeEmail, otherRecipients}} : null

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                assignee: cmdAssignee(assignee),
                ...requestNotificationTo,
                commandType: 'AcceptIntervention'
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticketId, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ACCEPT_INTERVENTION_CMD_SENT
            }
        })
    }, ACCEPT_INTERVENTION_CMD_SENT)
}

export function sendRefuseInterventionCmd(ticketId) {
    return loading((state) => {
        const {ticket} = state.ticket
        const {assignee} = ticket
        const ticketId = ticketId || ticket.uid

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                assignee: cmdAssignee(assignee),
                commandType: 'RefuseIntervention'
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticketId, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REFUSE_INTERVENTION_CMD_SENT
            }
        })
    }, REFUSE_INTERVENTION_CMD_SENT)
}

export function sendScheduleInterventionCmd() {
    return loading((state) => {
        const {ticket, scheduleInterventionCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                assignee: cmdAssignee(assignee),
                commandType: 'ScheduleIntervention',
                ...scheduleInterventionCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: SCHEDULE_INTERVENTION_CMD_SENT
            }
        })
    }, SCHEDULE_INTERVENTION_CMD_SENT)
}

export function sendStartInterventionCmd() {
    return loading((state) => {
        const {ticket, startInterventionCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                assignee: cmdAssignee(assignee),
                commandType: 'StartIntervention',
                ...startInterventionCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: START_INTERVENTION_CMD_SENT
            }
        })
    }, START_INTERVENTION_CMD_SENT)
}

export function sendFinishInterventionCmd() {
    return loading((state) => {
        const {ticket, finishInterventionCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                assignee: cmdAssignee(assignee),
                commandType: 'FinishIntervention',
                ...finishInterventionCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: FINISH_INTERVENTION_CMD_SENT
            }
        })
    }, FINISH_INTERVENTION_CMD_SENT)
}

export function sendAddMessageCmd() {
    return loading((state) => {
        const {ticket, addMessageCmd} = state.ticket
        const {assignee} = ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                messageAddedDate: new Date(),
                assignee: assignee && cmdAssignee(assignee),
                commandType: 'AddMessage',
                ...addMessageCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_MESSAGE_CMD_SENT
            }
        })
    }, ADD_MESSAGE_CMD_SENT)
}

export function sendCloseTicketCmd() {
    return loading((state) => {
        const {ticket, closeTicketCmd} = state.ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                closingDate: new Date(),
                date: new Date(), // used only by CancelTicket for legacy reasons
                stillOnSite: 'NotAsked',
                ...closeTicketCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: CLOSE_TICKET_CMD_SENT
            }
        })
    }, CLOSE_TICKET_CMD_SENT)
}

export function sendCorrectTicketInformationsCmd() {
    return loading((state) => {
        const {ticket, correctTicketInformationsCmd} = state.ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                commandType: 'CorrectTicketInformations',
                ...correctTicketInformationsCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: CORRECT_TICKET_INFORMATIONS_CMD_SENT
            }
        })
    }, CORRECT_TICKET_INFORMATIONS_CMD_SENT)
}

export function sendCorrectTicketEventInformationsCmd() {
    return loading((state) => {
        const {ticket, correctTicketEventInformationsCmd} = state.ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                commandType: 'CorrectTicketEventInformations',
                ...correctTicketEventInformationsCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT
            }
        })
    }, CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT)
}

export function sendReceiveCallCmd(ticketId) {
    return loading((state) => {
        const {receiveCallCmd} = state.ticket
        const {callerz, ...cmd} = receiveCallCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                commandType: 'ReceiveCall',
                caller: callerz,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticketId, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: RECEIVE_CALL_CMD_SENT
            }
        })
    }, RECEIVE_CALL_CMD_SENT)
}

export function sendEmitCallToCmd() {
    return loading((state) => {
        const {ticket, emitCallToCmd} = state.ticket
        const {recipient: {namez, provider, ...recipient}, ...cmd} = emitCallToCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                date: new Date(),
                commandType: 'EmitCallTo',
                recipient: {
                    name: namez,
                    provider: provider && cmdProvider(provider),
                    ...recipient
                },
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: EMIT_CALL_TO_CMD_SENT
            }
        })
    }, EMIT_CALL_TO_CMD_SENT)
}

export function sendFinishMissionCmd() {
    return loading((state) => {
        const {ticket, finishMissionCmd} = state.ticket

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                endMissionDate: new Date(),
                commandType: 'FinishMission',
                ...finishMissionCmd
            }
        }

        return fetch(config.api.event.url + '/tickets/' + ticket.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: FINISH_MISSION_CMD_SENT
            }
        })
    }, FINISH_MISSION_CMD_SENT)
}

export function exportXlsxTickets(exportOption) {
    return progress((state) => {
        const {query, exportXlsxTicketsOption} = state.ticket
        const worker = new Worker(WORKER_SCRIPT_PATH)

        exportOption = {
            ...exportXlsxTicketsOption,
            ...exportOption
        }

        worker.addEventListener('message', function(event) {
            switch(event.data.type) {
                case XLSX_EXPORT_COMPLETED:
                    FileSaver.saveAs(event.data.xlsx, 'export-' + moment().format(i18n.dateFormat.file) + '.xlsx')
                    break
            }
        })

        worker.postMessage({type: START_XLSX_EXPORT, query: query, option: exportOption})
        return worker
    }, XLSX_TICKETS_EXPORTED)
}

export function exportPdfTickets(exportOption) {
    return progress((state) => {
        const {query, exportPdfTicketsOption} = state.ticket
        const worker = new Worker(WORKER_SCRIPT_PATH)

        exportOption = {
            ...exportPdfTicketsOption,
            ...exportOption
        }

        worker.addEventListener('message', function(event) {
            switch(event.data.type) {
                case PDF_EXPORT_COMPLETED:
                    FileSaver.saveAs(event.data.pdf, 'export-' + moment().format(i18n.dateFormat.file) + '.pdf')
                    break
            }
        })

        worker.postMessage({type: START_PDF_EXPORT, query: query, option: exportOption})
        return worker
    }, PDF_TICKETS_EXPORTED)
}

export function exportPdfTicket(exportOption) {
    return progress((state) => {
        const {ticket} = state.ticket
        const worker = new Worker(WORKER_SCRIPT_PATH)

        exportOption = {
            pages: ['journal'],
            ...exportOption
        }

        worker.addEventListener('message', function(event) {
            switch(event.data.type) {
                case PDF_EXPORT_COMPLETED:
                    FileSaver.saveAs(event.data.pdf, 'export-' + ticket.uid + '.pdf')
                    break
            }
        })

        worker.postMessage({type: START_PDF_EXPORT, ticketId: ticket.uid, option: exportOption})
        return worker
    }, PDF_TICKETS_EXPORTED)
}

export function reportPdfTickets(reportQuery, reportOption) {
    return progress((state) => {
        const {authenticated} = state.user
        const {query, reportPdfTicketsOption} = state.ticket
        const worker = new Worker(WORKER_SCRIPT_PATH)

        reportQuery = {
            ...query,
            ...reportQuery
        }

        reportOption = {
            ...reportPdfTicketsOption,
            ...reportOption
        }

        worker.addEventListener('message', function(event) {
            switch(event.data.type) {
                case PDF_REPORT_COMPLETED:
                    FileSaver.saveAs(event.data.pdf, 'report-' + moment().format(i18n.dateFormat.file) + '.pdf')
                    break
            }
        })

        worker.postMessage({type: START_PDF_REPORT, authenticated: authenticated, query: reportQuery, option: reportOption})
        return worker
    }, PDF_TICKETS_REPORTED)
}

export function updateCriteria(criteria) {
    return {
        type: CRITERIA_UPDATED,
        criteria: criteria
    }
}

export function updateExportXlsxTicketsOption(option) {
    return {
        type: EXPORT_XLSX_TICKETS_OPTION_UPDATED,
        option: option
    }
}

export function updateReportPdfTicketsOption(option) {
    return {
        type: REPORT_PDF_TICKETS_OPTION_UPDATED,
        option: option
    }
}

export function updateOpenTicketCmd(cmd) {
    return {
        type: OPEN_TICKET_CMD_UPDATED,
        cmd: cmd
    }
}
export function updateCorrectLocationReferenceCmd(cmd) {
    return {
        type: CORRECT_LOCATION_REFERENCE_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateCorrectCallerCmd(cmd) {
    return {
        type: CORRECT_CALLER_CMD_UPDATED,
        cmd: cmd
    }
}

export function fetchDocumentsForOpenTicket() {
    return loading((state) => {
        return fetch(config.api.url + '/documents?aggregatetype=SimplifiedRequest&aggregateuid='+state.ticket.openTicketCmd.requestUid, apiOption())
            .then(apiResponse)
            .then(({json}) => {
                return {
                    type: OPEN_TICKET_CMD_UPDATED,
                    cmd: {
                        photos: json.documents
                    }
                }
            })
    })
}

export function resetOpenTicketCmd() {
    return {
        type: OPEN_TICKET_CMD_RESET
    }
}

export function updateIdentifyAssigneeCmd(cmd) {
    return {
        type: IDENTIFY_ASSIGNEE_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateCloseTicketCmd(cmd) {
    return {
        type: CLOSE_TICKET_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateStartInterventionCmd(cmd) {
    return {
        type: START_INTERVENTION_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateFinishInterventionCmd(cmd) {
    return {
        type: FINISH_INTERVENTION_CMD_UPDATED,
        cmd: cmd
    }
}

export function resetCorrectTicketInformationsCmd(cmd) {
    return {
        type: CORRECT_TICKET_INFORMATIONS_CMD_RESET,
        cmd: cmd
    }
}

export function updateCorrectTicketEventInformationsCmd(cmd) {
    return {
        type: CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateReceiveCallCmd(cmd) {
    return {
        type: RECEIVE_CALL_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateEmitCallToCmd(cmd) {
    return {
        type: EMIT_CALL_TO_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateFinishMissionCmd(cmd) {
    return {
        type: FINISH_MISSION_CMD_UPDATED,
        cmd: cmd
    }
}

export function chooseIfSendNotificationWhenInterventionAccepted(cmd) {
    return {
        type: ACCEPT_INTERVENTION_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateOtherRecipientInInterventionAcceptedNotification(cmd) {
    return {
        type: ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL,
        ...cmd
    }
}

export function createTicket() {
    return {
        type: TICKET_CREATED,
        ticket: {
            additionalDataz: {},
            stats: {},
            journal: [],
            _links: []
        }
    }
}

function cmdProvider(providerContact) {
    const {uid} = providerContact

    return {
        providerType: 'ReferencedProvider',
        providerUid: uid
    }
}

function cmdAssignee(ticketAssignee) {
    const {uid, assigneeType, ...assignee} = ticketAssignee

    switch(assigneeType) {
        case 'ProviderContact':
            return {
                providerUid: uid,
                assigneeType: 'ReferencedProviderContact'
            }
        case 'ProviderCompany':
            return {
                providerUid: uid,
                assigneeType: 'ReferencedProviderCompany'
            }
        case 'Anonymous':
            return {
                providerUid: uid,
                assigneeType: 'AnonymousAssignee',
                ...assignee
            }
    }
}


// WEBPACK FOOTER //
// ./lib/ticket/actions.js